import { render, staticRenderFns } from "./LabeledContent.vue?vue&type=template&id=1a2bdb9e&scoped=true&"
import script from "./LabeledContent.vue?vue&type=script&lang=js&"
export * from "./LabeledContent.vue?vue&type=script&lang=js&"
import style0 from "./LabeledContent.vue?vue&type=style&index=0&id=1a2bdb9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bdb9e",
  null
  
)

export default component.exports